var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.node,{tag:"component",staticClass:"button button-elem",class:[_vm.iconClass, _vm.spinnerClass],on:{"click":function($event){return _vm.$emit('click', $event)}}},[_vm._t("default"),(_vm.spinner)?_c('spinner-elem'):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }